module.exports = __webpack_public_path__ + "static/img/13.d1812d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/13.jpg
// module id = 5cW9
// module chunks = 0